import client from '@/services/http/client'

export interface AuthMeResponse {
  account: string
  display_name: string
  email: string | null
  roles: string[]
  permissions: string[]
  source: string
  status: string
  must_change_password?: boolean
  scopes: {
    groups: string[]
    group_details: Array<{
      room_id: string
      scope_type: string
      scope_source: 'base' | 'share' | 'base+share'
      base_scope_type: string | null
      share_batch_ids: number[]
      source_accounts: string[]
      source_display_names: string[]
    }>
    projects: number[]
    tickets: Record<string, unknown>[]
  }
  external_accounts: {
    provider: string
    external_account: string
    external_name: string | null
  }[]
}

export async function fetchAuthMe(): Promise<AuthMeResponse> {
  const { data } = await client.get<AuthMeResponse>('/auth/me')
  return data
}

export async function loginWithPassword(payload: {
  account: string
  password: string
}): Promise<AuthMeResponse> {
  const { data } = await client.post<AuthMeResponse>('/auth/login', payload)
  return data
}

export async function logoutSession(): Promise<void> {
  await client.post('/auth/logout')
}

export async function changePassword(payload: {
  old_password: string
  new_password: string
}): Promise<void> {
  await client.post('/auth/password/change', payload)
}
